export default __webpack_public_path__ + "static/data-vis-text-charts-dont-8faa61373b6ebcef7c4d5c3521cf02f1.png";